import { TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import {
  customElement,
  property,
  queryAssignedElements,
} from 'lit/decorators.js';

import { PCAccordionPanel } from './pc-accordion-panel/pc-accordion-panel';
import globalStyles from './pc-accordion.lightDom.css.lit';

/**
 * The Accordion component
 * @element pc-accordion
 */
@customElement('pc-accordion')
export class PCAccordion extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: Number, attribute: 'default-index-panel' })
  defaultIndexPanel: number;

  /**
   * Reference to <pc-accordion-panel> in panels slot.
   */
  @queryAssignedElements()
  panels: PCAccordionPanel[];

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  protected firstUpdated(): void {
    if (this.defaultIndexPanel !== undefined && this.panels[this.defaultIndexPanel]) {
      const defaultPanel = this.panels[this.defaultIndexPanel];
      defaultPanel.defaultActive = true;
    }
  }

  render(): TemplateResult {
    return html`
      <section class="accordion" @keydown=${this.handleKeyboardNav}>
        <slot></slot>
      </section>
    `;
  }

  /**
   * @param event
   * @returns void
   * Adds up/down arrow keyboard navigation.
   * TODO: try to refactor to something simpler.
   */
  handleKeyboardNav(event: KeyboardEvent) {
    let index = 0;

    const panels = this.panels;
    const start = Array.prototype.indexOf.call(
      panels,
      event.target as HTMLElement
    );

    // bail on wrong key
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }
    if (event.key === 'ArrowDown') {
      if (panels?.length && start + 1 > panels?.length - 1) {
        index = 0;
      } else index = start + 1;
    }
    if (event.key === 'ArrowUp') {
      if (panels?.length && start - 1 < 0) {
        index = panels?.length - 1;
      } else index = start - 1;
    }
    const focusTarget = panels?.[index] as unknown as HTMLElement;
    focusTarget.shadowRoot?.querySelector('button')?.focus();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-accordion': PCAccordion;
  }
}
